import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import {
   Pagination, LabelContainerModel, LabelService,
} from 'blg-akaun-ts-lib';
import { AppConfig } from '../../visa';
import { forkJoin, iif, Observable, of, ReplaySubject, Subject } from 'rxjs';
import { debounceTime, tap, filter, switchMap, distinctUntilChanged, map, mergeMap, takeUntil } from 'rxjs/operators';
import { SubSink } from 'subsink2';

@Component({
  selector: 'app-select-tariff-code',
  templateUrl: './select-tariff-code.component.html',
  styleUrls: ['./select-tariff-code.component.scss']
})

export class SelectTariffCodeComponent implements OnInit, OnDestroy {
  @Input() label = new FormControl();
  @Output() labelSelected = new EventEmitter<LabelContainerModel>();
  serverSideSearching = false;
  selectedEntity: LabelContainerModel;
  private subs = new SubSink();
  labels: any = [];
  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<LabelContainerModel[]> = new ReplaySubject<LabelContainerModel[]>(1);
  labelList: LabelContainerModel[];
  serverSideFiltering = new FormControl();
  protected _onDestroy = new Subject<void>();
  labelListGuid: any;
  constructor( private labelService: LabelService ) {}

  ngOnInit() {
    setTimeout(() => {
    if (this.label && this.label.value) {
      this.onPatchValue(this.label.value);
    }}, 1500);
    this.labelListGuid = '00000000-0000-0000-0000-000000000002'
    this.serverSideFiltering.valueChanges
    .pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.filtering();
  });
    this.getAll()
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterLabel(resolve)});
    
  }

  filtering() {
    if (!this.labels) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.labels.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredOptions$.next(
      this.labels.filter((option) =>
        (option.bl_fi_mst_label_hdr.name ?
          option.bl_fi_mst_label_hdr.name.toLowerCase().indexOf(search) > -1 : null))
    );
  }

  filterLabel(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.labelList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.labelList.filter(c => c.bl_fi_mst_label_hdr.name.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  onPatchValue(guid: string) {
    this.labelService.getByGuid(guid, this.apiVisa).pipe(
      takeUntil(this._onDestroy)
    ).subscribe( resolved => {
      //this.labelList = [resolved.data];
      this.filteredOptions$.next([resolved.data]);
      this.onSelect(resolved.data.bl_fi_mst_label_hdr.guid.toString());
    });
  }

  getAll(){
      this.labelList = [];
      this.labels = [];
      this.filteredOptions$.next(this.labels.slice());
      //if there is a selected company
      if (this.labelListGuid) {    
              let paging = new Pagination();
              paging.conditionalCriteria = [];
              paging.conditionalCriteria.push
              ({ columnName: 'label_list_guid', operator: '=', value: this.labelListGuid.toString() });

              this.labelService.getByCriteria(paging, this.apiVisa).subscribe(label => {
                let emptyOption = new LabelContainerModel();
                this.labels.push(emptyOption);
                this.labelList.push(emptyOption);
                label.data.forEach((data) => {
                  this.labels.push(data);
                  this.labelList.push(data);
                });

                // sorting
                const sorted = this.labels.sort((a, b) => (a.bl_fi_mst_label_hdr.code < b.bl_fi_mst_label_hdr.code ? -1 : 1));
                //fill the drop down
                this.filteredOptions$.next(this.labels.slice());
              })

      }

  }

  onSelect(guid: string) {
    console.log("select tariff",guid)
    if (guid) {
      this.label.patchValue(guid);
      this.selectedEntity = this.labelList.find(y => y.bl_fi_mst_label_hdr.guid === guid);
      this.labelSelected.emit(this.selectedEntity);
     
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
